import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Box, Card, Flex, Group, Image, Select, Stack, TextInput, Tooltip } from "@mantine/core";
import { CloseOutlined, EditOutlined, InsertDriveFileOutlined } from "@mui/icons-material";
import { useRef } from "react";
export const FileUploadPreviewCard = ({ index, fileEntry, fileTypeOptions, onRemove, onUpdate }) => {
    const inputRef = useRef(null);
    const isPreviewable = fileEntry.file.type.startsWith("image/") || !!fileEntry.thumbnailUrl;
    const handleEditClick = (e) => {
        e.stopPropagation();
        onUpdate(index, "name", "");
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };
    return (_jsxs(Card, { p: "xs", onClick: (e) => e.stopPropagation(), style: {
            border: "1px solid var(--mantine-color-gray-2)",
            borderRadius: "16px",
            backgroundColor: "var(--mantine-color-white)",
            position: "relative",
            minWidth: 160,
            transition: "all 0.2s ease"
        }, children: [_jsx(ActionIcon, { color: "var(--mantine-color-red-5)", variant: "filled", size: "sm", pos: "absolute", top: 5, right: 5, onClick: (e) => {
                    e.stopPropagation();
                    onRemove(index);
                }, style: {
                    position: "absolute",
                    top: 5,
                    right: 5,
                    zIndex: 10,
                    borderRadius: "50%",
                    boxShadow: "0 2px 8px color-mix(in srgb, var(--mantine-color-black) 20%, transparent)"
                }, children: _jsx(CloseOutlined, { style: { fontSize: 14 } }) }), _jsxs(Stack, { gap: 10, align: "center", children: [_jsx(Flex, { variant: "image-preview", children: isPreviewable ? (_jsx(Image, { src: fileEntry.thumbnailUrl || fileEntry.url, w: "100%", h: "100%", style: { objectFit: "cover" } })) : (_jsx(InsertDriveFileOutlined, { style: {
                                fontSize: 48,
                                color: "var(--mantine-color-gray-5)"
                            } })) }), _jsxs(Stack, { gap: 0, w: "100%", children: [_jsxs(Group, { gap: 0, justify: "center", wrap: "nowrap", w: "100%", children: [_jsx(Box, { style: { flex: 1, minWidth: 0 }, children: _jsx(Tooltip, { label: fileEntry.name, disabled: !fileEntry.name, position: "top", openDelay: 500, withinPortal: true, children: _jsx(TextInput, { ref: inputRef, variant: "unstyled", size: "xs", placeholder: "File name", value: fileEntry.name, onChange: (e) => onUpdate(index, "name", e.currentTarget.value) }) }) }), _jsx(ActionIcon, { variant: "transparent", color: "gray", size: "xs", onClick: handleEditClick, children: _jsx(EditOutlined, { style: { fontSize: 14 } }) })] }), _jsx(Select, { variant: "unstyled", size: "xs", data: fileTypeOptions, value: fileEntry.fileType, onChange: (val) => onUpdate(index, "fileType", val) })] })] })] }));
};
